// Package imports:
import React from 'react';
// Component imports:
import Table from 'react-bootstrap/Table';
// Service imports:
import { formatDate, formatNumber } from '../../services/utils';
// Type imports:
import { PublicTradeTickData } from '../../types/api/PublicTypes';

interface IOwnProps {
    matchedTrades: PublicTradeTickData[];
    member: string | null;
}

const MatchedTrades: React.FC<IOwnProps> = ({ matchedTrades, member }) => {
    return (
        <div id='MatchedTrades'>
            <h5 className='SectionTitle'>
                Member Trades
                {member && <span className='MemberLabel'> ({member})</span>}
            </h5>
            <Table className='CompressedTable'>
                <thead>
                    <tr>
                        <th scope='col'>Time</th>
                        <th scope='col'>Buyer</th>
                        <th scope='col' className='text-center'>Aggressor</th>
                        <th scope='col'>Seller</th>
                        <th scope='col' className='text-right'>Price</th>
                        <th scope='col' className='text-right'>Volume</th>
                        <th scope='col' className='text-right'>Value</th>
                        <th scope='col'>Role</th>
                    </tr>
                </thead>
                <tbody>
                    {matchedTrades.length === 0 ? (
                        <tr className='NoClick'>
                            <td className='text-left EmptyTableText' colSpan={8}>
                                No trades found for this member on this day.
                            </td>
                        </tr>
                    ) : (
                        matchedTrades.map((trade, i) => {
                            const isBuyer = trade.trade_buyer === member;
                            const isSeller = trade.trade_seller === member;
                            const role = (isBuyer && isSeller) ? 'Both' : isBuyer ? 'Buyer' : 'Seller';
                            return (
                                <tr
                                    key={trade.trade_id ?? i}
                                    className={trade.trade_cancel !== 'N' ? 'cancelled' : undefined}
                                >
                                    <td>{formatDate(trade.timestamp, true, true)}</td>
                                    <td className={isBuyer ? 'highlight-member' : undefined}>{trade.trade_buyer}</td>
                                    <td className='text-center'>
                                        {trade.aggressive_party === 'S' ? '<' : trade.aggressive_party === 'B' ? '>' : null}
                                    </td>
                                    <td className={isSeller ? 'highlight-member' : undefined}>{trade.trade_seller}</td>
                                    <td className='text-right'>{formatNumber(trade.price)}</td>
                                    <td className='text-right'>{formatNumber(trade.volume, 'volume')}</td>
                                    <td className='text-right'>{formatNumber(trade.value, 'volume')}</td>
                                    <td><span className={`RoleBadge ${role}`}>{role}</span></td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default MatchedTrades;
